module.exports = __webpack_public_path__ + "static/media/tutorial2.3ce9bb59.gif";